import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { BfsgAccessibilityComponent } from './bfsg-accessibility.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [BfsgAccessibilityComponent],
	imports: [CommonModule, IonicModule, TranslateModule.forChild()],
	exports: [BfsgAccessibilityComponent],
})
export class BfsgAccessibilityModule {}
